/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CaseMatchCaseDiagnosis } from './CaseMatchCaseDiagnosis';
import type { CaseMatchPatient } from './CaseMatchPatient';
import type { CaseMatchSpecimen } from './CaseMatchSpecimen';
import type { UserName } from './UserName';

export type CaseMatches = {
    readonly id?: number;
    /**
     * The Accession Number of the Case
     */
    accession: string | null;
    readonly patient?: CaseMatchPatient;
    readonly specimens?: Array<CaseMatchSpecimen>;
    /**
     * current workflow status of the case
     */
    status?: CaseMatches.status;
    /**
     * case type: Clinical, Test, Demo, Validation, Consult, TC PC Split, or Historical
     */
    type?: CaseMatches.type;
    readonly ordering_doctor?: UserName;
    readonly case_diagnosis: Array<CaseMatchCaseDiagnosis>;
    readonly report_id?: number;
    readonly finalized_report_id?: number;
    /**
     * Changing this value will NOT modify the collected_date for each specimen.
     */
    collected_date?: string | null;
    /**
     * Changing this value will NOT modify the received_date for each specimen.
     */
    received_date?: string | null;
}

export namespace CaseMatches {

    /**
     * current workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }

    /**
     * case type: Clinical, Test, Demo, Validation, Consult, TC PC Split, or Historical
     */
    export enum type {
        CLINICAL = 'clinical',
        TEST = 'test',
        DEMO = 'demo',
        VALIDATION = 'validation',
        CONSULT = 'consult',
        CONTROL = 'control',
        TC_PC = 'tc-pc',
        HISTORICAL = 'historical',
        EDUCATION = 'education',
        NON_DIAGNOSTIC = 'non-diagnostic',
        MOHS_QC = 'mohs-qc',
        TRIAGE = 'triage',
    }


}
